"use client"

import { useEffect } from "react"

import { fadeGainsForTeardown } from "./attachSpeakerMeter"

/**
 * A full page unload (refresh, tab close) never runs React cleanup in time
 * to fade — hook the unload itself and start the ramp immediately, so the
 * audio thread has the fade underway before the page is torn down.
 */
export function useUnloadAudioFade(
  audioContextRef: { current: AudioContext | null },
  gainNodesRef: { current: GainNode[] },
) {
  useEffect(() => {
    const fadeForUnload = () => {
      fadeGainsForTeardown(audioContextRef.current, gainNodesRef.current)
    }
    window.addEventListener("pagehide", fadeForUnload)
    window.addEventListener("beforeunload", fadeForUnload)
    return () => {
      window.removeEventListener("pagehide", fadeForUnload)
      window.removeEventListener("beforeunload", fadeForUnload)
    }
  }, [audioContextRef, gainNodesRef])
}
